const navigationList = [
  {
    name: "审核管理",
    icon: require("../assets/imgs/rizhi.svg"),
    path: "",
    child: [
      {
        name: "报名信息审核2022",
        icon: "",
        path: "/layout/info2022",
      },
      {
        name: "报名信息审核2023",
        icon: "",
        path: "/layout/information",
      },
      {
        name: "报名信息审核2024",
        icon: "",
        path: "/layout/info2024",
      },
    ],
  },
  {
    name: "运营管理",
    icon: require("../assets/imgs/yunying.svg"),
    path: "",
    child: [
      {
        name: "大赛快讯管理",
        icon: "",
        path: "/layout/mediaReports",
      },
      {
        name: "成果展示管理",
        icon: "",
        path: "/layout/resultsShow",
      },
      {
        name: "消息通知管理",
        icon: "",
        path: "/layout/messageNotice",
      },
      {
        name: "下载浏览器管理",
        icon: "",
        path: "/layout/downloadChrome",
      },
    ],
  },
  {
    name: "比赛管理",
    icon: require("../assets/imgs/yunying.svg"),
    path: "",
    child: [
      {
        name: "上传资料时间",
        icon: "",
        path: "/layout/uploadData",
      },
    ],
  },
  {
    name: "用户管理",
    icon: require("../assets/imgs/yonghu.svg"),
    path: "",
    child: [
      {
        name: "注册用户管理",
        icon: "",
        path: "/layout/registered",
      },
      {
        name: "后台用户管理",
        icon: "",
        path: "/layout/background",
      },
    ],
  },
  {'':''}
];
const navigationList_c = [
  {
    name: "首页",
    icon: "",
    path: "/layout_c/index",
  },
  {
    name: "大赛公告",
    icon: "",
    path: "/layout_c/announcement",
  },
  {
    name: "大赛报名",
    icon: "",
    path: "/layout_c/signUp",
  },
  {
    name: "我的比赛",
    icon: "",
    path: "/layout_c/game",
  },
  {
    name: "问题和解答",
    icon: "",
    path: "/layout_c/problem",
  },
];

exports.navigationList_c = navigationList_c;
exports.navigationList = navigationList;
